module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    staticClass: "fullscreen"
  }, [_c('md-card-media', {
    staticClass: "fullscreen"
  }, [_c('swiper', {
    ref: "storyboard",
    staticClass: "fullscreen",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((77), function(id) {
    return _c('swiper-slide', {
      key: id
    }, [_c('img', {
      staticClass: "swiper-lazy",
      attrs: {
        "data-src": "static/movie/1988-" + (id > 9 ? id : ("0" + id)) + ".png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper-lazy-preloader swiper-lazy-preloader-white"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev swiper-button-white",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next swiper-button-white",
    slot: "button-next"
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-music"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPlaying),
      expression: "isPlaying"
    }],
    attrs: {
      "src": require("../assets/play.gif"),
      "alt": "click turn off music"
    },
    on: {
      "click": function($event) {
        _vm.toggleMusic()
      }
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPlaying),
      expression: "!isPlaying"
    }],
    attrs: {
      "src": require("../assets/stop.gif"),
      "alt": "click turn on music"
    },
    on: {
      "click": function($event) {
        _vm.toggleMusic()
      }
    }
  }), _vm._v(" "), _c('audio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "id": "musicPlayer",
      "src": "static/audio/1988.mp3",
      "autoplay": "autoplay",
      "loop": "loop"
    },
    on: {
      "canplay": _vm.startAutoPlay
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-358bcf83"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Childhood.vue
// module id = 24
// module chunks = 0